import React from 'react'
import { Field, reduxForm } from 'redux-form/immutable'
import { InjectedFormProps } from 'redux-form'
import { Map } from 'immutable'
import { WithStyles, withStyles } from '@mui/styles'
import { withNamespaces, WithNamespaces } from 'react-i18next'
import { FormTextField, Button, jumpToFirstError } from '@syncfab/machine'
import { Typography, Grid } from '@mui/material'
import { EMAIL_REGEX } from '../../../../utils/Regex'
import { CardElement } from 'react-stripe-elements'
export const PaymentFormName: string = 'PaymentFormName'

const styles = theme => ({
    action: {
        minWidth: 120,
    },
    iconHeight: {
        height: '32px',
    },
    footerText: {
        marginTop: theme.spacing(5),
        'text-align': 'center',
    },
    partsCaption: {
        marginBottom: theme.spacing(2),
    },
    links: {
        'text-transform': 'none',
        color: theme.palette.primary.light,
    },
    newAddressButton: {
        padding: 0,
    },
    cardElement: {
        borderStyle: 'solid',
        borderRadius: '4px',
        borderWidth: '1px',
        color: theme.palette.grey['400'],
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        padding: '18.5px 14px',
    },
})

type PaymentFields = {
    email?: string
}

const validate = (data: Map<string, string>): {} => {
    const errors: PaymentFields = {}
    ;['email', 'nameOnCard', 'zip', 'expiryDate', 'cvc', 'country', 'cardNumber'].forEach(field => {
        if (!data.get(field)) {
            errors[field] = 'Required'
        }
    })
    if (data.get('email') && !EMAIL_REGEX.test(data.get('email') || '')) {
        errors.email = 'Invalid email'
    }

    return errors
}

interface FormState {}

interface FormProperties {
    amount?: string
}

interface FormProps
    extends InjectedFormProps<{}, {}>,
        //amount:number
        WithStyles<typeof styles>,
        WithNamespaces,
        FormProperties {}

class PaymentFormView extends React.Component<FormProps, FormState> {
    constructor(props) {
        super(props)
        this.props.reset()
        this.state = {}
    }

    render() {
        const { handleSubmit, classes, amount } = this.props
        const {} = this.state
        return (
            <form onSubmit={handleSubmit}>
                <Grid container alignContent="center">
                    <Grid item xs={12}>
                        <Typography color="inherit" variant="h6">
                            Email
                        </Typography>
                        <Field name="email" component={FormTextField} variant="outlined" type="text" fullWidth />
                    </Grid>

                    <Grid item xs={12}>
                        <CardElement className={classes.cardElement} />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <Typography color="inherit" variant="h6">
                            Card information
                        </Typography>

                        <Field
                            name="cardNumber"
                            component={FormTextField}
                            type="text"
                            placeholder="1234 1234 1234 1234"
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="start">
                                        <img className={classes.iconHeight} src="https://cdn.freebiesupply.com/logos/large/2x/visa-logo-png-transparent.png" />
                                        <img className={classes.iconHeight} src="https://cdn2.iconfinder.com/data/icons/credit-cards-6/156/mastercard-512.png" />
                                        <img className={classes.iconHeight} src="https://cdn2.iconfinder.com/data/icons/credit-cards-6/156/american_express-512.png" />
                                        <img className={classes.iconHeight} src="https://cdn.iconscout.com/icon/free/png-256/payment-unionpay-card-pay-bank-credit-transaction-51328.png" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Grid container item xs={12} direction="row">
                            <Grid item xs={6}>
                                <Field name="expiryDate" component={FormTextField} type="text" placeholder="MM/YY" fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs={6}>
                                <Field
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <img
                                                    className={classes.iconHeight}
                                                    src="data:image/png;base64,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"
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                    name="cvc"
                                    xs={6}
                                    component={FormTextField}
                                    type="text"
                                    placeholder="CVC"
                                    fullWidth
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                    </Grid> 
                 */}
                    <Grid item xs={12}>
                        <Typography color="inherit" variant="h6">
                            Name on card
                        </Typography>
                        <Field name="nameOnCard" component={FormTextField} type="text" fullWidth variant="outlined" />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="inherit" variant="h6">
                            Country or region
                        </Typography>
                        <Field name="country" component={FormTextField} type="text" fullWidth variant="outlined" />
                        {/* <Field name="zip" placeholder="ZIP" component={FormTextField} type="text" fullWidth variant="outlined" /> */}
                    </Grid>
                    <Grid container item xs={12}>
                        <Button type="submit" fullWidth color="secondary" className={classes.action}>
                            {/* {t('pay $ 11.50')} */}
                            pay $ {amount}
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.footerText}>
                    <Grid container item justifyContent="center" direction="row" spacing={2}>
                        <Grid>
                            {' '}
                            <Typography color="textSecondary" align="center">
                                Powered By
                            </Typography>
                        </Grid>
                        <Grid style={{ marginLeft: '4px' }}>
                            <Typography color="textSecondary" align="center" variant="h6">
                                Stripe
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container item justifyContent="center" direction="row" style={{ marginTop: '16px' }}>
                        <Grid>
                            {' '}
                            <Typography color="textSecondary" align="center">
                                Terms
                            </Typography>
                        </Grid>
                        <Grid style={{ marginLeft: '4px' }}>
                            <Typography color="textSecondary" align="center">
                                Privacy
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* <Typography color="textSecondary" align="center">
                        Terms Privacy
                    </Typography> */}
                </Grid>
                {/* <AddressDialog onSubmit={this.onSaveAddress as any} onSaveUpdate={submitAddressForm} close={this.toggleAddressDialog} open={addressDialogOpen} /> */}
            </form>
        );
    }
}

const translatedForm = withStyles(styles)(withNamespaces()(PaymentFormView))
export const PaymentForm = reduxForm<{}, FormProperties>({
    form: PaymentFormName,
    validate,
    onSubmitFail: jumpToFirstError,
    // initialValues: Map().set('sameAsBilling', true),
})(translatedForm as any) // ReduxForm types are not good
